import PubSub from 'pubsub-js';
import enquire from 'enquire.js';
import { PageEvents } from './page';
import { Responsive } from '../utils';
import { TextColorCheck } from '../utils/textColorCheck';

import './title.scss';

const COMPONENT_NAME = 'title';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Title)
 */
export class Title {
  constructor() {
    const self = this;

    this._els = {
      title: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.title.each(function () {
        const $instanceEl = $(this);
        TextColorCheck._checkBackground($instanceEl);

        const $titleEl = $instanceEl.find('.title__title');
        const fontSizeDesktop = $titleEl.data('font-size-desktop');
        const fontSizeMobile = $titleEl.data('font-size-mobile');
        const lineHeightDesktop = $titleEl.data('line-height-desktop');
        const lineHeightMobile = $titleEl.data('line-height-mobile');

        if (fontSizeDesktop || fontSizeMobile || lineHeightDesktop || lineHeightMobile) {
          enquire.register(`${Responsive.getBreakpointMaxMediaQuery('sm')}`, {
            match() {
              $titleEl.children().each(function () {
                if (fontSizeMobile) {
                  $(this).css('font-size', fontSizeMobile);
                }
                if (lineHeightMobile) {
                  $(this).css('line-height', lineHeightMobile);
                }
              });
            },
          });

          enquire.register(`${Responsive.getBreakpointMinMediaQuery('md')}`, {
            match() {
              $titleEl.children().each(function () {
                if (fontSizeDesktop) {
                  $(this).css('font-size', fontSizeDesktop);
                }
                if (lineHeightDesktop) {
                  $(this).css('line-height', lineHeightDesktop);
                }
              });
            },
          });
        }
      });
    });
  }
}
